import React, { FormEvent, Fragment, PureComponent, ReactNode } from 'react';
import Icon from '../../../icons/Icon';
import ComponentService from '../../../service/ComponentService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { Link } from 'react-router-dom';
import ComponentName from '../../../constant/ComponentName';
import EmptyComponent from '../empty-components/EmptyComponent';
import CustomDismissible from '../CustomDismissible';
import LanguageUtil from '../../../util/LanguageUtil';

class GlobalSearchComponent extends PureComponent<Props, State> {
  public state = new State();

  private componentService: ComponentService = ServiceContainer.getInstance().get(ServiceNames.COMPONENT);
  private timeoutId: NodeJS.Timeout | undefined;

  public render(): ReactNode {
    const { sidebar } = this.props;
    const { search, isOpen } = this.state;
    return (
      <CustomDismissible key={'global-search'} id={'global-search'} onDismiss={() => this.setState({ isOpen: false })}>
        <div
          id={'global-search'}
          className={` ${sidebar ? 'w-full mb-5' : ''} w-[600px] z-[500] xl:h-[28px] 2xl:h-[32px] hover:border-f-purple rounded-[4px] border-transparent border-[1px]  flex items-center justify-center group relative`}
        >
          <div
            onClick={() => this.setState({ isOpen: !isOpen })}
            className={
              'flex w-full xl:h-[28px] 2xl:h-[32px] items-center bg-[#FFFFFF1A] rounded-[4px] focus-within:border-f-purple  focus-within:indent-0  focus-within:formica-shadow hover:border-[#728EFF] relative'
            }
          >
            <div className={`top-0 left-0 h-full w-full bg-[#111111] -z-1 opacity-30 ${isOpen ? 'fixed' : 'hidden'}`}></div>
            <Icon icon={'search'} size={24} className={'text-[#D0D0D0] rounded px-1 py-1 ml-1'} />
            <input
              className={`h-[32px] focus:outline-none border-none outline-none w-full bg-transparent transition-all text-[#D0D0D0] text-sm 2xl:text-2xs rounded indent-2`}
              value={search}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.searchDot', defaultMessage: 'Search...' })}
              onChange={this.onSearchChange}
            />
          </div>
          <div
            className={`${isOpen ? 'flex h-auto' : 'hidden h-[0px]'} duration-800 transition-all  items-start justify-start w-full box-border overflow-y-hidden overflow-x-hidden absolute top-10 bg-white border-[1px] border-[E0E4E8] rounded-[8px] left-0`}
          >
            {search.length < 3 && (
              <div className={'flex items-center justify-start gap-x-3 text-xl text-black px-5 py-5 w-full'}>
                <span className={'text-red-500 font-bold'}>{LanguageUtil.get({ id: 'common.label.beta', defaultMessage: 'Beta' })}</span>
                <Icon icon={'warning'} className={'text-f-black-2'} size={20} />
                <p className={'text-f-black-2'}>
                  {LanguageUtil.get({ id: 'common.label.typeAt', defaultMessage: 'Type at ' })}
                  <strong>{LanguageUtil.get({ id: 'common.label.3characters', defaultMessage: 'least 3 characters' })}</strong>
                  {LanguageUtil.get({ id: 'common.label.toSearch', defaultMessage: 'to search' })}
                </p>
              </div>
            )}
            {search.length >= 3 && (
              <Fragment>
                <div className={'flex justify-start items-start flex-col w-[50%] h-full'}>
                  <p className={'h-10 flex items-center text-md text-f-black-2 border-b-[1px] border-[#E0E4E8] w-full px-3 py-3'}>Category</p>
                  <ul className={'flex flex-col min-w-[200px] shrink-0 max-h-[330px] overflow-y-scroll '}>{this.getCategories()}</ul>
                </div>
                <div className={'flex justify-center items-start flex-col w-full'}>
                  <p className={'h-10 flex items-center text-md text-f-black-2 border-b-[1px] border-[#E0E4E8] w-full px-3 py-3'}>Search Result</p>
                  <ul
                    className={`flex flex-col gap-y-2 my-2 w-full max-h-[380px] overflow-y-scroll ${Object.keys(this.state.response).length > 0 && 'border-l'}`}
                  >
                    {this.getSearchResults()}
                  </ul>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </CustomDismissible>
    );
  }

  private getCategories = (): ReactNode => {
    const { response } = this.state;
    const keys = ['All', ...Object.keys(response)];
    return keys.map((k) => {
      let iconName: string = k.toLowerCase();
      if (iconName == 'velocity' || iconName == 'basicvariable' || iconName == 'queryvariable' || iconName == 'apivariable' || iconName == 'listvariable') {
        iconName = 'enrichment';
      }
      return (
        <li
          onClick={() => this.setState({ component: k as ComponentName })}
          className={'h-10 flex items-center hover:bg-main-gray w-full cursor-pointer justify-start text-md text-f-black-2 px-3 py-3 gap-x-2 '}
          key={k}
        >
          <Icon icon={iconName != 'All' ? iconName : 'dashboard'} size={16} />
          {this.executeKeyName(k)}
        </li>
      );
    });
  };

  private executeKeyName = (key: string) => {
    switch (key) {
      case 'Transaction':
        return 'Channel';
      case 'Case':
        return 'Transaction';
      default:
        return key;
    }
  };

  private getSearchResults = (): ReactNode => {
    const { component, response } = this.state;
    let results: SearchModel[] = [];
    if (component == 'All') {
      results = Object.values(response).flatMap((r) => r) as SearchModel[];
    } else {
      results = response[component];
    }
    if (results && results.length > 0) {
      return results.map((r: SearchModel, i: number) => {
        const targetUrl = r.component === ComponentName.LIST ? this.resolveListUrl(r.url) : this.calculateUrl(r.url);
        let iconName = r.component.toLowerCase();
        if (iconName == 'velocity' || iconName == 'basicvariable' || iconName == 'queryvariable' || iconName == 'apivariable' || iconName == 'listvariable') {
          iconName = 'enrichment';
        }
        return (
          <li className={'flex w-full items-center justify-start cursor-pointer hover:bg-[#F9FAFB] '} key={i}>
            <Link
              className={'flex  w-full items-center justify-start gap-x-3 px-3 py-3'}
              to={targetUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              <div className={'inline-  flex w-auto h-full items-center'}>
                <span className={'flex items-center justify-center w-8 h-8 rounded-[50%] bg-secondary'}>
                  <Icon className={'text-f-purple'} icon={iconName} size={16} />
                </span>
              </div>
              <span className={'flex flex-col w-full h-10'}>
                <div className={'flex w-full h-full text-f-black-2'}>{r.title}</div>
                <div className={'flex w-full h-full truncate text-f-black-3'}>{r.description || 'This component does not have description yet'}</div>
              </span>
            </Link>
          </li>
        );
      });
    } else {
      return <EmptyComponent type={component as any} />;
    }
  };

  private onSearchChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ search: e.currentTarget.value }, () => {
      this.restartSearch();
    });
  };

  private executeSearch = async () => {
    const { search } = this.state;
    if (search == undefined || search.length == 0) return;
    const response = await this.componentService.globalSearch(search);
    this.setState({ response });
  };

  private restartSearch = () => {
    if (this.timeoutId == undefined) {
      this.timeoutId = setTimeout(async () => {
        await this.executeSearch();
      }, 200);
    } else {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
      this.restartSearch();
    }
  };

  private calculateUrl = (url: string) => {
    return url;
  };

  private resolveListUrl = (url: string): string => {
    return url.replace('/list/internal_list/edit/', '/list/file/edit/').replace('/list/external_list/edit/', '/list/query/edit/');
  };
}

interface Props {
  sidebar: boolean;
}

class State {
  search: string = '';
  response: SearchResult = {};
  component: ComponentName | 'All' = 'All';
  isOpen: boolean = false;
}

interface SearchModel {
  title: string;
  description?: string;
  component: ComponentName;
  url: string;
}

export type SearchResult = Record<string, SearchModel[]>;

export default GlobalSearchComponent;
